var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-input"},[_c('span',{staticClass:"input-label"},[_vm._v(_vm._s(_vm.labelText))]),_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }